import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_ea3884f8-0ad1-4240-91ed-bcb907817db7/artifacts/rs9cus7r_ebn%20one%20logo.png";
